import React from 'react';
import {twMerge} from 'tailwind-merge';
import LinearImage from '../linear-image/linear-image';
import { Partners } from '../organization-and-partners/organization-and-partners.type';


interface ConcertPartnerProps {
    partners: Partners[];
    containerClassName?: string;
    contentContainerClassName?: string;
}

const ConcertPartnersMobile: React.FC<ConcertPartnerProps> = ({
    partners,
    containerClassName,
    contentContainerClassName,
}) => {
    const containerStyle = twMerge(
        `h-full w-full rounded-2xl flex flex-col justify-start items-center`,
        containerClassName,
    );
    const contentContainerStyle = twMerge(
        `flex flex-wrap justify-center items-center gap-[4px]`,
        contentContainerClassName,
    );
    return (
        <div
            className="p-1 rounded-2xl w-full"
            style={{
                background:
                    'linear-gradient(290.93deg, #DABA03 18.72%, #FFF04D 37.08%, #FFFDBD 43.79%, #CEAF00 57.39%, #FFFDBD 66.64%, #FFE659 77.01%)',
            }}>
            <div
                className={containerStyle}
                style={{
                    background: 'linear-gradient(103.28deg, #FFFEE6 1.06%, #F6E989 95.93%)',
                }}>
                <div className={contentContainerStyle}>
                    {partners.map(item => (
                        <LinearImage
                            className={'w-[15%] min-w-[75px] aspect-[53/25] lg:aspect-[150/70] xl:max-w-[150px] rounded-[5px]'}
                            key={item.name}
                            src={item.src}
                            width={item.width}
                            height={item.height}
                            alt={item.name}
                            imageClassName="rounded-[5px] object-contain"
                            imageContainerClassName="rounded-[5px] md:!p-[2px] p-[1px]"
                        />
                    ))}
                </div>
            </div>
        </div>
    );
};

export default ConcertPartnersMobile;
